import { useQuery } from '@tanstack/react-query';
import type { CommercialDashboardQuery } from '@troia-v3/types';

import { dashboardsCommercialApi } from '../services/dashboardsCommercialApi';

const QUERY_KEY = 'dashboards-commercial';

/**
 * Fetches the commercial dashboard payload for a given period.
 *
 * Suporta 4 modos:
 * - week    → últimos 7 dias rolling
 * - month   → exige `year` + `month`
 * - year    → exige `year`
 * - custom  → exige `startDate` + `endDate`
 *
 * Cached for 60s. Habilitado quando os params do modo são suficientes.
 */
export const useCommercialDashboard = (params: CommercialDashboardQuery) => {
  const enabled = (() => {
    if (params.period === 'week') return true;
    if (params.period === 'month') return !!params.year && !!params.month;
    if (params.period === 'year') return !!params.year;
    if (params.period === 'custom') return !!params.startDate && !!params.endDate;
    return false;
  })();

  return useQuery({
    queryKey: [
      QUERY_KEY,
      params.period,
      params.year,
      params.month,
      params.startDate,
      params.endDate,
      params.unitId,
      params.unitState,
    ],
    queryFn: () => dashboardsCommercialApi.get(params),
    staleTime: 60_000,
    enabled,
  });
};
